import { Component, OnInit } from "@angular/core";

@Component({
  selector: "mis-employee-web-exp-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"]
})
export class LoaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
